import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../Context/auth-context';
import MainHeader from './MainHeader';
import NavLinks from './NavLinks';
import SideDrawer from './SideDrawer';
import Backdrop from '../UIElements/Backdrop';
import Icon from '../UIElements/Icon';
import ProfileAvatar from '../UIElements/ProfileAvatar';
import Logo from '../UIElements/Logo';
import './MainNavigation.css';
const Brand = () => (
  <Link to="/" className="brand" aria-label="Curentia home">
    <Logo />
  </Link>
);
const MainNavigation = () => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const auth = useContext(AuthContext);
  const location = useLocation();
  const loggedIn = auth.isDoctorLoggedIn || auth.isPateintLoggedIn || auth.isPharmacyLoggedIn;
  const role = auth.isDoctorLoggedIn ? 'Doctor' : auth.isPateintLoggedIn ? 'Patient' : 'Pharmacy';
  const user = auth.doctor || auth.patient || auth.pharmacy;
  const closeDrawerHandler = () => setDrawerIsOpen(false);
  useEffect(() => {
    setDrawerIsOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    if (!drawerIsOpen) return;
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setDrawerIsOpen(false);
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [drawerIsOpen]);
  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <div className="drawer-heading">
          <Brand />
          <button
            className="icon-button"
            aria-label="Close navigation"
            onClick={closeDrawerHandler}
          >
            <Icon name="close" />
          </button>
        </div>
        <nav aria-label="Mobile navigation" className="main-navigation__drawer-nav">
          <NavLinks />
        </nav>
      </SideDrawer>
      {loggedIn && (
        <aside className="app-sidebar">
          <Brand />
          <p className="sidebar-label">{role} workspace</p>
          <nav aria-label="Main navigation">
            <NavLinks />
          </nav>
          <div className="sidebar-note">
            <Icon name="pulse" size={24} />
            <p>
              Care, connected.<span>Your everyday care workspace.</span>
            </p>
          </div>
        </aside>
      )}
      <MainHeader>
        {loggedIn ? (
          <>
            <button
              className="main-navigation__menu-btn icon-button"
              aria-label="Open navigation"
              aria-expanded={drawerIsOpen}
              onClick={() => setDrawerIsOpen(true)}
            >
              <Icon name="menu" />
            </button>
            <span className="workspace-label">
              My workspace <span>/</span> <strong>{role}</strong>
            </span>
            <div className="header-account">
              <div>
                <strong>{user?.name}</strong>
                <span>{role} account</span>
              </div>
              <ProfileAvatar name={user?.name} />
            </div>
          </>
        ) : (
          <>
            <Brand />
            <span className="guest-header-note">A little more connected. A lot more care.</span>
            {location.pathname !== '/' && (
              <Link className="guest-nav-link" to="/">
                All roles <Icon name="arrow" size={17} />
              </Link>
            )}
          </>
        )}
      </MainHeader>
    </>
  );
};
export default MainNavigation;
